<template>
  <div class="mapInfo modal">
    <div class="modal_inner">
      <div class="nav">
        <button class="modal_back" @click="back"></button>
        <button
          class="modal_toggle"
          :class="[iconName]"
          @click="toggle"
        ></button>
      </div>
      <Map :state="state" :station="stationList[stationIndex]" height="65vh" />
      <div class="dscr_wrap">
        <div class="title">
          <h4>정류장 위치 안내</h4>
          <Swipe
            class="control swiper"
            :navigation="true"
            @slideChange="(swiper) => slideChange(swiper)"
          >
            <template #swiperSlide>
              <swiper-slide
                v-for="(station, index) in stationList"
                :key="`station${index}`"
              >
                <!-- 정류장명  -->
                <span class="route_name">{{ station.name }}</span>
                <!-- //정류장명  -->
              </swiper-slide>
            </template>
          </Swipe>
        </div>
        <BaseInfo :infoList="infoList" />
        <button class="btnB modal_close" @click="back">닫기</button>
      </div>
    </div>
  </div>
</template>

<script>
import Map from "@/components/Map/Map";
import Swipe from "@/components/Swipe";

import { SwiperSlide } from "swiper/vue";
import BaseInfo from "@/components/Base/BaseInfo.vue";
import { ref, onMounted } from "vue";

export default {
  name: "MapInfo",
  components: {
    Map,
    Swipe,
    SwiperSlide,
    BaseInfo,
  },
  props: {
    stationList: {
      type: Array,
      default: () => [
        {
          name: "테스트 정류장 POV",
          lat: 37.40471573855188,
          lng: 127.0975985120266,
          povLat: 37.40471573855188,
          povLng: 127.0975985120266,
          povBearing: 0.0,
          povTilt: 0.0,
          povFov: 90.0,
          povZoom: 1.0,
        },
        {
          name: "테스트 정류장 POV2",
          lat: 37.402885318824,
          lng: 127.10318852277,
          povLat: 37.402885318824,
          povLng: 127.10318852277,
          povBearing: 0.0,
          povTilt: 0.0,
          povFov: 90.0,
          povZoom: 1.0,
        },
        {
          name: "테스트 정류장 POV",
          lat: 37.40471573855188,
          lng: 127.0975985120266,
          povLat: 37.40471573855188,
          povLng: 127.0975985120266,
          povBearing: 0.0,
          povTilt: 0.0,
          povFov: 90.0,
          povZoom: 1.0,
        },
        {
          name: "테스트 정류장 POV2",
          lat: 37.402885318824,
          lng: 127.10318852277,
          povLat: 37.402885318824,
          povLng: 127.10318852277,
          povBearing: 0.0,
          povTilt: 0.0,
          povFov: 90.0,
          povZoom: 1.0,
        },
      ],
    },
    nowStationIndex: {
      type: Number,
      default: 0,
    },
  },
  data: () => ({
    infoList: [
      "정류장 정보는 참고용으로만 사용해주세요. 정보차이는 일정 부분 불가피하며, 보증할 수 없습니다. 관련 착오는 이용자의 책임입니다.",
    ],
  }),
  setup(props, { emit }) {
    const state = ref("map");
    const iconName = ref("roadview_icon");
    const toggle = () => {
      state.value = state.value === "map" ? "roadview" : "map";
      iconName.value =
        iconName.value === "roadview_icon" ? "map_icon" : "roadview_icon";
    };

    const back = () => {
      emit("closeMapInfo");
    };

    const stationIndex = ref(props.nowStationIndex);
    const slideChange = (swiper) => {
      stationIndex.value = swiper.realIndex;
    };

    onMounted(() => {
      const swiper = document.querySelector(".swiper").swiper;
      swiper.slideTo(stationIndex.value);
    });
    return { toggle, back, slideChange, state, stationIndex, iconName };
  },
};
</script>
